import React from 'react'
import * as R from 'ramda'
import { Modal } from 'semantic-ui-react'

import useModal from 'hooks/useModal'
import { CardGroup } from 'components/Card'
import SurveyTypeButton from 'components/SurveyTypeButton'
import { EmbedIntegrationsSection } from 'components/EmbedIntegrationsSection'
import { Loader } from 'shared/components/Loader'
import { useDynamicConstants } from 'config/dynamicConstants'
import constants from 'config/constants'

/**
 *
 * @param {object} props
 * @param {function} props.onChange
 * @param {boolean} [props.loading]
 * @param {boolean} [props.enableOneoffEmailSurvey]
 */
export function SurveyDeliveryMethodInput({ onChange, loading, enableOneoffEmailSurvey }) {
  const embedSurveyModal = useModal()
  const emailSurveyModal = useModal()

  const dynamicConstants = useDynamicConstants()
  const embedIntegrations = dynamicConstants.surveyConfigurations.map((helpdesk) => ({
    name: helpdesk.name,
    label: helpdesk.label,
    iconUrl: helpdesk.iconUrl,
    connectorId: R.prop('connectorId', helpdesk) || null,
  }))

  return (
    <React.Fragment>
      <embedSurveyModal.Modal>
        <Modal.Header>Choose where to add your survey</Modal.Header>
        <Modal.Content className="relative">
          {loading && <Loader style={{ zIndex: 6 }} />}
          <p>
            For Gmail, Outlook, or any other service not listed below, choose{' '}
            <strong>Generic Embed</strong>.
          </p>
          <EmbedIntegrationsSection
            onClick={(embedIntegration) => onChange(embedIntegration)}
            embedIntegrations={embedIntegrations}
          />
        </Modal.Content>
      </embedSurveyModal.Modal>
      <emailSurveyModal.Modal>
        <Modal.Header>Choose the email delivery type</Modal.Header>
        <Modal.Content className="relative pv4">
          {loading && <Loader style={{ zIndex: 6 }} />}
          <div className="ui three cards stackable centered">
            {enableOneoffEmailSurvey && (
              <SurveyTypeButton
                name="One-off"
                description="Send scheduled or immediate email survey blasts to your customer base."
                icon={
                  <img
                    src={constants.oneOffEmailIcon}
                    alt="green right pointing arrow"
                    width={124}
                    height={124}
                  />
                }
                onClick={() => onChange({ name: 'oneoff_email', connectorId: null })}
              />
            )}
            <SurveyTypeButton
              name="Ongoing"
              description="Put email surveys on autopilot after choosing a delivery audience."
              icon={
                <img
                  src={constants.ongoingEmailIcon}
                  alt="yellow cycle arrows"
                  width={124}
                  height={124}
                />
              }
              onClick={() => onChange({ name: 'ongoing_email', connectorId: null })}
            />
            <SurveyTypeButton
              name="Event-based"
              description="Send scheduled or immediate email survey blasts to your customer."
              icon={
                <img
                  src={constants.eventBasedEmailIcon}
                  alt="blue lightening bolt"
                  width={124}
                  height={124}
                />
              }
              onClick={() => onChange({ name: 'event_based_email', connectorId: null })}
            />
          </div>
        </Modal.Content>
      </emailSurveyModal.Modal>
      <CardGroup centered>
        <SurveyTypeButton
          className="mr2"
          name="External email embed"
          description="Embed your survey in any service desk, CRM, Gmail, or Outlook."
          icon={
            <img
              src={constants.externalEmailEmbedIcon}
              alt="purple envelope with code symbol"
              width={124}
              height={124}
            />
          }
          onClick={embedSurveyModal.open}
        />
        <SurveyTypeButton
          name="Direct email delivery"
          description="Import or sync your customers, then
          send emails directly from Simplesat."
          icon={
            <img
              src={constants.directEmailIcon}
              alt="blue envelope outline"
              width={124}
              height={124}
            />
          }
          onClick={emailSurveyModal.open}
        />
        <SurveyTypeButton
          className="mr2"
          name="Web-embed"
          description="Embed a survey in any app or web page."
          icon={
            <img
              src={constants.webEmbedIcon}
              alt="green web browser outline with code symbol"
              width={124}
              height={124}
            />
          }
          onClick={() => onChange({ name: 'web_embed', connectorId: null })}
        />
      </CardGroup>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyDeliveryMethodInput/index.js